export const network = {
    accessLog: 'Netzwerk-Zugriffsprotokoll',
    viewAccessLog: 'Zugriffsprotokoll ansehen',
    accessLogHint: 'Erfolgreiche Profilaufrufe, neueste zuerst. Eigene Aufrufe und Suchergebnisse werden nicht erfasst.',
    loadingViews: 'Profilaufrufe werden geladen…',
    noProfileViews: 'Noch keine Profilaufrufe',
    noProfileViewsHint: 'Hier erscheinen Besuche, sobald andere Netzwerkteilnehmer dieses Profil öffnen.',
    loadViewsError: 'Die Profilaufrufe konnten nicht geladen werden.',
    newestViews: 'Neueste Aufrufe',
    olderViews: 'Ältere Aufrufe',
    title: 'Netzwerk',
    viewNetwork: 'Netzwerk ansehen',
    description: 'Finde Menschen in deinen Organisationen und vernetze dich.',
    participationRequired: 'Tritt dem Netzwerk dieser Organisation bei, um andere Profile zu sehen. Öffne dein Profil, um deine geteilten Angaben zu prüfen und der Teilnahme zuzustimmen.',
    chooseOrganization: 'Organisation auswählen',
    search: 'Namen und geteilte Profilinformationen suchen',
    filters: 'Filter',
    empty: 'Keine passenden Profile',
    emptyMessage: 'Versuche eine andere Suche oder ändere deine Filter.',
    unavailable: 'Dieses Netzwerk ist nicht verfügbar',
    unavailableMessage: 'Das Netzwerk wurde möglicherweise deaktiviert oder dein Zugang hat sich geändert.',
    noValue: 'Nicht angegeben',
    yes: 'Ja',
    no: 'Nein',
    retry: 'Erneut versuchen',
    all: 'Alle',
    profileViewsPage: {
        refresh: 'Aktualisieren',
        title: 'Profilaufrufe',
        action: 'Wer hat mein Profil angesehen?',
    },
    join: {
        title: 'Dem Netzwerk beitreten',
        action: 'Netzwerk beitreten',
        description: 'Prüfe dein Profil oben und wähle aus, welche optionalen Angaben du mit anderen Teilnehmenden teilen möchtest.',
        sharedFields: 'Dein Name wird immer geteilt. Weitere erforderliche Angaben: {{fields}}.',
        nameOnly: 'keine',
        optionalFields: 'Optional geteilte Angaben',
        reciprocalHint: 'Du kannst optionale Angaben nur sehen, wenn du sie auch selbst teilst.',
        consentTitle: 'Einwilligung zur Teilnahme',
        privacy: 'Datenschutzhinweise lesen',
        privacyError: 'Die Datenschutzhinweise konnten nicht geöffnet werden.',
        withdrawal: 'Du kannst deine Einwilligung widerrufen, indem du in den Details deines verknüpften Kontakts das Netzwerk verlässt.',
        managedWithdrawal: 'Kontaktiere deine Organisation, um deine Einwilligung zu widerrufen und das Netzwerk zu verlassen.',
        accept: 'Ich stimme der Teilnahme zu',
        saved: 'Du bist dem Netzwerk beigetreten.',
    },
    profilePage: {
        manageMyProfile: 'Mein Profil verwalten',
        saved: 'Gespeichert',
        title: 'Profil',
        profileDetails: 'Profilinformationen',
        contactDetails: 'Kontaktdaten',
        reviewed: 'Zuletzt bestätigt',
        reviewPrompt: 'Bitte prüfe dein Profil und bestätige, dass deine Angaben aktuell sind.',
        confirmReview: 'Profil als aktuell bestätigen',
        preview: 'Noch nicht geteilt. Nur du siehst diese Vorschau, bis du dem Netzwerk beitrittst.',
        editContact: 'Kontaktdaten bearbeiten',
        visibleFields: 'Sichtbare Eigenschaften auswählen',
        leave: {
            action: 'Netzwerk verlassen',
            description: 'Dein Profil wird im Netzwerk ausgeblendet. Du kannst erneut teilnehmen, indem du der Teilnahme zustimmst.',
        },
    },
    customFields: 'Zusatzfelder',
    errors: {
        selfJoin: 'Deine Organisation erlaubt keinen selbstständigen Beitritt.',
        consentChanged: 'Die Teilnahmebedingungen haben sich geändert. Bitte prüfe die aktualisierten Informationen und versuche es erneut.',
        profileViewLimit: 'Du hast dein Limit von {{limit}} Profilen pro 24 Stunden erreicht. Ab {{availableAt}} kannst du ein weiteres Profil öffnen. Bereits angesehene Profile bleiben verfügbar.',
        viewInProgress: 'Ein anderes Profil wird gerade geöffnet. Bitte versuche es gleich noch einmal.',
        optOut: 'Deine Organisation verwaltet den Widerruf der Netzwerkeinwilligung. Bitte wende dich an sie.',
        access: 'Du hast keinen Zugang zu diesem Netzwerk.',
        consent: 'Nimm am Netzwerk teil, bevor du andere Profile ansiehst.',
        field: 'Dieses Feld ist nicht verfügbar oder kann hier nicht geändert werden.',
        invalid: 'Bitte prüfe deine Angaben.',
    },
}
